import { FormEvent, useId, useState } from "react";

import { useTranslation } from "next-i18next";

import useSignupForNewsletter from "@/Apollo/hooks/useSignupForNewsletter";
import { analyticsService } from "@/common/services/analytics/analytics.service";
import { EMAIL } from "@/scenes/auth/register/Constants";
import { Button } from "@/ui/cva/Button";
import { Input } from "@/ui/cva/input/Input";
import { Body } from "@/ui/typography/Body";

export const NewsLetterForm = () => {
  const { t } = useTranslation();
  const [isSent, setIsSent] = useState(false);
  const [signup, { loading }] = useSignupForNewsletter();

  const inputId = useId();

  /*
   * ponytail: one email field with native `type="email"` validation, so a plain
   * uncontrolled form does the job. react-hook-form was ~29 KB in the shared
   * _app chunk on every page — the Footer is in MainLayout — to trim a string.
   * Reach for useForm again if this grows real per-field validation.
   */
  const handleSubmitForm = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    const email = String(
      new FormData(event.currentTarget).get(EMAIL) ?? ""
    ).trim();

    if (!email) {
      return;
    }

    try {
      await signup({
        variables: {
          email,
        },
      });

      // /** Trigger `hp_newsletter_subscription` event. */
      analyticsService.trackHpNewsletterSubscription();

      setIsSent(true);
    } catch (ex) {
      console.log((ex as Error).message);
    }
  };

  if (isSent) {
    return <Body as="span">{t("footer:newsletter-form-success-message")}</Body>;
  }

  return (
    <form className="flex gap-x-2" onSubmit={handleSubmitForm}>
      <label htmlFor={inputId} className="sr-only">
        {t("common:newsletter-signup_email_input_placeholder")}
      </label>
      <Input
        id={inputId}
        color="brand"
        type="email"
        name={EMAIL}
        placeholder={t("common:newsletter-signup_email_input_placeholder")}
        autoComplete="email"
      />
      <Button
        className="min-w-[50%]"
        loading={loading}
        type="submit"
        appearance="outlined"
        aria-label={t("common:newsletter-signup_submit_button")}
      >
        {t("common:newsletter-signup_submit_button")}
      </Button>
    </form>
  );
};
